import type { SpotlightRect } from '../../../shared/ui/common/WorkspaceSpotlightTour';

export type ValidationChromeControllerId =
  | 'validation-workspace-tab'
  | 'validation-guide'
  | 'validation-tour'
  | 'validation-theme'
  | 'validation-summary';

const HOST_RIBBON_HEIGHT = 34;
const HOST_RIBBON_TOP = 0;

interface ControllerLayout {
  leftOffset: number;
  width: number;
}

const controllerLayouts: Record<ValidationChromeControllerId, ControllerLayout> = {
  'validation-workspace-tab': { leftOffset: 280, width: 110 },
  'validation-guide': { leftOffset: -172, width: 34 },
  'validation-tour': { leftOffset: -134, width: 34 },
  'validation-theme': { leftOffset: -96, width: 34 },
  'validation-summary': { leftOffset: -58, width: 34 },
};

export const getValidationChromeControllerRect = (
  id: ValidationChromeControllerId,
  viewportWidth: number
): SpotlightRect => {
  const layout = controllerLayouts[id];
  const left = layout.leftOffset < 0 ? viewportWidth + layout.leftOffset : layout.leftOffset;

  return {
    top: HOST_RIBBON_TOP,
    left: Math.max(8, left),
    width: layout.width,
    height: HOST_RIBBON_HEIGHT,
  };
};

export const validationChromeControllers = (
  viewportWidth: number
): Record<ValidationChromeControllerId, SpotlightRect> => ({
  'validation-workspace-tab': getValidationChromeControllerRect('validation-workspace-tab', viewportWidth),
  'validation-guide': getValidationChromeControllerRect('validation-guide', viewportWidth),
  'validation-tour': getValidationChromeControllerRect('validation-tour', viewportWidth),
  'validation-theme': getValidationChromeControllerRect('validation-theme', viewportWidth),
  'validation-summary': getValidationChromeControllerRect('validation-summary', viewportWidth),
});
